angular.module('LeasePilot').controller('PasswordSettingsController', [
  '$scope',
  '$http',
  '$mdToast',
  function($scope, $http, $mdToast) {
    $scope.passwords = {
      current: '',
      new: '',
      confirm: ''
    };
    $scope.showPasswords = {
      current: false,
      new: false,
      confirm: false
    };
    $scope.saving = false;
    $scope.isValid = {
      length: false,
      uppercase: false,
      lowercase: false,
      numbers: false,
      special: false,
      all: false
    };

    function showToast(message, type = "success") {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(message)
          .position("top right")
          .hideDelay(3000)
          .theme(type === "error" ? "error-toast" : "success-toast")
      );
    }

    $scope.togglePasswordVisibility = function(field) {
      $scope.showPasswords[field] = !$scope.showPasswords[field];
    };

    $scope.validatePassword = function(password) {
      if (!password) {
        $scope.isValid = {
          length: false,
          uppercase: false,
          lowercase: false,
          numbers: false,
          special: false,
          all: false
        };
        return;
      }

      $scope.isValid.length = password.length >= 8;
      $scope.isValid.uppercase = /[A-Z]/.test(password);
      $scope.isValid.lowercase = /[a-z]/.test(password);
      $scope.isValid.numbers = /[0-9]/.test(password);
      $scope.isValid.special = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      
      $scope.isValid.all = 
        $scope.isValid.length && 
        $scope.isValid.uppercase && 
        $scope.isValid.lowercase && 
        $scope.isValid.numbers && 
        $scope.isValid.special;
    };

    $scope.init = function() {
      // No need to fetch any data, just initialize the form
    };

    $scope.hasChanges = function() {
      return $scope.passwords.current && 
             $scope.passwords.new && 
             $scope.passwords.confirm && 
             $scope.passwords.new === $scope.passwords.confirm &&
             $scope.isValid.all;
    };

    $scope.saveChanges = function() {
      if (!$scope.hasChanges()) return;

      if ($scope.passwords.new !== $scope.passwords.confirm) {
        showToast('New password and confirmation do not match', 'error');
        return;
      }

      if (!$scope.isValid.all) {
        showToast('Password does not meet all requirements', 'error');
        return;
      }

      $scope.saving = true;
      
      $http.put(`/api/password/${window.user.id}`, {
        user: {
          current_password: $scope.passwords.current,
          password: $scope.passwords.new,
          password_confirmation: $scope.passwords.confirm
        }
      }).then(function() {
        showToast('Password updated successfully');
        // Reset form
        $scope.passwords = {
          current: '',
          new: '',
          confirm: ''
        };
        $scope.showPasswords = {
          current: false,
          new: false,
          confirm: false
        };
        $scope.passwordForm.$setPristine();
        $scope.passwordForm.$setUntouched();
        $scope.validatePassword('');
      }).catch(function(error) {
        showToast(error.data.error || 'Failed to update password', 'error');
      }).finally(function() {
        $scope.saving = false;
      });
    };
  }
]); 